import axios from './axios';

const historyProducts = (currentLanguage) => {
  return axios.get('/api/info/historyProduct', {
    headers: {
      'Accept-Language': currentLanguage,
    },
  });
};

const historyProductDetail = (currentLanguage, eventRouter) => {
  return axios.get(`/api/info/historyProduct/detail?eventRoute=${eventRouter}`, {
    headers: {
      'Accept-Language': currentLanguage,
    },
  });
};

export { historyProducts, historyProductDetail };
